var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 20H5.33317C4.62593 20 3.94765 19.719 3.44755 19.2189C2.94746 18.7188 2.6665 18.0405 2.6665 17.3333V5.33329C2.6665 4.62605 2.94746 3.94777 3.44755 3.44767C3.94765 2.94758 4.62593 2.66663 5.33317 2.66663H17.3332C18.0404 2.66663 18.7187 2.94758 19.2188 3.44767C19.7189 3.94777 19.9998 4.62605 19.9998 5.33329V6.66663M14.6665 12H26.6665C28.1393 12 29.3332 13.1939 29.3332 14.6666V26.6666C29.3332 28.1394 28.1393 29.3333 26.6665 29.3333H14.6665C13.1937 29.3333 11.9998 28.1394 11.9998 26.6666V14.6666C11.9998 13.1939 13.1937 12 14.6665 12Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bf9778fed8b6abd7b2dd074a09d0d322.svg";
export { ForwardRef as ReactComponent };